module.exports = "<div style=\"height: 40px; border-bottom: 1px solid;\" class=\"lane\"></div>\n<div id=\"applet_container1\"></div>\n<button (click)=\"save()\">Save</button>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/geogebra/geogebra.component.html
// module id = ../../../../../src/app/wb/geogebra/geogebra.component.html
// module chunks = main